<template>
  <div>
<!--  招标  -->
    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item>数据统计</el-breadcrumb-item>
      <el-breadcrumb-item>合同执行效率分析</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <el-form ref="form" :model="serchForm" :inline="true" label-width="auto">
      <el-form-item label="部门名称：" prop="proname">
        <el-select v-model="serchForm.depart_id" placeholder="请选择部门查询后显示数据" style="width:300px" @change="changeName">
          <el-option
            v-for="item in depData"
            :key="item.id"
            :label="item.department_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目签约日期：" prop="create_time">
        <el-date-picker
          v-model="serchForm.create_time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:300px"
          value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="项目类别：">
        <el-select v-model="serchForm.project_type" placeholder="请选择项目类别" style="width:200px">
          <el-option
            v-for="item in leibie"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left: 40px">
        <el-button type="primary" class="btn-add" @click="getData"
                   style="margin-bottom:28px;background-color:rgb(133,206,97);border: rgb(133,206,97); box-shadow: 0px 3px 13px 0px rgba(133,206,97, 0.38);">
          查询
        </el-button>
<!--        <el-button type="primary" class="btn-add" @click="clearData"-->
<!--                   style="margin-bottom:28px;background-color:rgb(247,137,137);border: rgb(247,137,137); box-shadow: 0px 3px 13px 0px rgba(247,137,137, 0.38);margin-left: 40px">-->
<!--          清空查询-->
<!--        </el-button>-->
        <el-button type="primary" class="btn-add" @click="export_ex" style="margin-left: 40px">导出
        </el-button>
      </el-form-item>
    </el-form>

    <div v-if="showTab && showYear" style="margin: -20px 0 20px 0;font-size: 16px">年度内合同总金额:<span style="font-weight: 700;margin-right: 20px"> {{parseFloat(count_year.contract_amount__sum).toFixed(2)}}万元</span>     年度内签约项目总数量: <span style="font-weight: 700;margin-right: 20px">{{count_year.id__count}}</span></div>

    <div v-if="showTab">
    <el-table
      :data="tableData"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}">
      <el-table-column
        prop="departments_name"
        label="部门"
        align="center"
        >
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.departments_name" :key="index">{{item.department_name}};  </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="proname"
        align="center"
        min-width="300"
        label="项目名称">
      </el-table-column>
      <el-table-column
        prop="project_type"
        align="center"
        width="160"
        label="项目类别">
      </el-table-column>
      <el-table-column
        prop="contract_amount"
        align="center"
        label="合同金额（万元）"
        width="160"
      >
        <template slot-scope="scope">
          {{parseFloat(scope.row.contract_amount).toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="start_date"
        align="center"
        label="启动日期">
      </el-table-column>
      <el-table-column
        prop="closing_time"
        align="center"
        label="关闭日期">
      </el-table-column>
      <el-table-column
        prop="service_time"
        align="center"
        label="项目执行时长（天）">
      </el-table-column>
    </el-table>

    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange">
    </Pagination>

    </div>  </div>
</template>

<script>
import {get_department, get_departments, performance} from '../../api/user'
import Pagination from "../../components/Pagination";

export default {
  // 注册组件
  components: {
    Pagination
  },
  data(){
    return{
      leibie:[
        {
          value:'投资',
          label:'投资'
        },{
          value:'客研',
          label:'客研'
        },{
          value:'定位',
          label:'定位'
        },{
          value:'培训',
          label:'培训'
        },{
          value:'系统',
          label:'系统'
        },{
          value:'战略',
          label:'战略'
        },{
          value:'数据',
          label:'数据'
        },
      ],
      //年内统计
      count_year:{},
      showYear:false,
      showTab:false,
      serchForm:{
        depart_id:'',
        create_time:'',
        project_type:''
      },
      serchRules:[],
      depData:[],

      tableData:[],
      //合计
      num:0,
      department_name:'',
      depart_id:'',
      total:'',
      limit:100,
      currentPage:1,
      isSerch:false
    }
  },
  methods:{
    //导出
    export_ex(){
      if(this.isSerch) {
        let url = '/api/performance?'
        let time = ''
        let id = ''
        let type = ''
        if(this.serchForm.create_time == ''){
          time = ''
        }else{
          time = '&create_time='+this.serchForm.create_time
        }
        if(this.serchForm.depart_id == ''){
          id = ''
        }else{
          id = '&department_id='+this.serchForm.depart_id
        }
        if(this.serchForm.project_type == ''){
          type = ''
        }else{
          type = '&project_type='+this.serchForm.project_type
        }

        window.open(url+time+id+type, '_blank')

        // if(this.serchForm.create_time == '' && this.serchForm.depart_id == '' && this.serchForm.project_type == '') {
        //   window.open('/api/performance?' + 'export_excel=1', '_blank');
        // }else if(this.serchForm.create_time != '' && this.serchForm.depart_id == '' && this.serchForm.project_type == ''){
        //   window.open('/api/performance?' + 'export_excel=1&create_time='+this.serchForm.create_time, '_blank');
        // }else if(this.serchForm.create_time == '' && this.serchForm.depart_id != '' && this.serchForm.project_type == ''){
        //   window.open('/api/performance?' + 'export_excel=1&department_id='+this.serchForm.depart_id, '_blank');
        // }else if(this.serchForm.create_time != '' && this.serchForm.depart_id != '' && this.serchForm.project_type == ''){
        //   window.open('/api/performance?' + 'export_excel=1&department_id='+this.serchForm.depart_id+'&create_time='+this.serchForm.create_time, '_blank');
        // }
      }else{
        this.$message.error('请查询后再导出！')
      }
    },
    changeName(val){
      for (let i = 0; i < this.depData.length; i++) {
        if(val == this.depData[i].id){
          this.department_name = this.depData[i].department_name
        }
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: this.tableData.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //获取所有数据
    getData(){
      let paramas = {
        departments_id:this.serchForm.depart_id,
        create_time:this.serchForm.create_time,
        project_type:this.serchForm.project_type,
        page:this.currentPage,
        limit:100
      }
      performance(paramas).then(res =>{
        if(res.code == 200){
          this.isSerch = true
          this.showTab = true
          this.tableData = res.data
          this.total = res.total
          this.num = 0
          for (let i = 0; i < this.tableData.length; i++) {
            this.num = parseInt(this.tableData[i].contract_amount) + parseInt(this.num)
          }
          if(res.count_year) {
            this.showYear = true
            this.count_year = res.count_year
          }else{
            this.showYear = false
          }
        }else {
          this.$message.error(res.msg)
        }
      })
    },


    //获取部门
    getDept() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
     get_departments(params).then(res => {
        if (res.code === 200) {
          this.depData = res.data;
          // this.limit = res.limit;
          // this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },

  },
  mounted(){
    this.isSerch = false
    this.getDept()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/statement/bid.vue